module.exports = __webpack_public_path__ + "fonts/Prompt-SemiBold.ba9b20ec.ttf";